import { useMutation } from '@tanstack/react-query'
import { brandingApi, UploadLogoPayload } from '../api/branding.api'
import { brandingKeys } from '../api/branding.keys'

const fileToBase64 = (file: File): Promise<string> =>
    new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => {
            const result = reader.result as string
            const base64 = result.split(',')[1]
            if (!base64) {
                reject(new Error('Invalid file data'))
                return
            }
            resolve(base64)
        }
        reader.onerror = (error) => reject(error)
        reader.readAsDataURL(file)
    })

export function useUploadLogo() {
    return useMutation<string, Error, File>({
        mutationKey: brandingKeys.uploadLogo(),
        mutationFn: async (file: File) => {
            const base64 = await fileToBase64(file)
            const payload: UploadLogoPayload = {
                data: base64,
                fileName: file.name,
                contentType: file.type || 'image/png',
            }
            return brandingApi.uploadLogo(payload)
        },
    })
}
